import { render, staticRenderFns } from "./LoadingTypeCard.vue?vue&type=template&id=79085003&scoped=true"
import script from "./LoadingTypeCard.vue?vue&type=script&lang=ts"
export * from "./LoadingTypeCard.vue?vue&type=script&lang=ts"
import style0 from "./LoadingTypeCard.vue?vue&type=style&index=0&id=79085003&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79085003",
  null
  
)

export default component.exports